import { PORTRAIT_URL } from '@moal/api'
import PropTypes from 'prop-types'
import React, { useEffect, useReducer } from 'react'
import { PORTRAIT_READY } from '../constants/actions/analyticsActions'
import useExternalScript from '../hooks/useExternalScript'
import useIsPortraitReady from '../hooks/useIsPortraitReady'
import { analyticsReducer, initialState } from '../reducers/analyticsReducer'

export const AnalyticsContext = React.createContext({})

export const AnalyticsProvider = ({ children }) => {
  const [state, dispatch] = useReducer(analyticsReducer, initialState)
  const externalScriptStatus = useExternalScript(PORTRAIT_URL)
  const isPortraitReady = useIsPortraitReady()

  useEffect(() => {
    if (isPortraitReady) {
      dispatch({ type: PORTRAIT_READY, payload: isPortraitReady })
    }
  }, [isPortraitReady, externalScriptStatus])

  // Update identity and store the value
  const updateIdentity = (email) => {
    if (state.portraitIsReady) {
      const { Portrait } = window
      Portrait.store('promo_email', { email }, () => {
        // Stash in Data Layer as well
        Portrait.dataLayer.identity.email = email
        return true
      })
    } else return false
  }

  const updatePageMeta = (metaObject) => {
    if (state.portraitIsReady) {
      const { Portrait } = window
      const {
        dataLayer: { page }
      } = Portrait
      Portrait.dataLayer.page = { ...page, ...metaObject }
    }
  }

  const pushEvent = (category, action, label) => {
    if (state.portraitIsReady) {
      const { dataLayer } = window
      dataLayer.push({
        event: 'event_triggered',
        event_category: category,
        event_action: action,
        event_label: label
        // anythingelse: 'moredata'
      })
    }
  }

  const persistTrackingParams = (search, blacklist) => {
    if (!sessionStorage.getItem('query_params') && search) {
      const urlParams = new URLSearchParams(search)
      const blacklistedValues = {}

      blacklist.forEach((param) => {
        const value = urlParams.get(param)
        if (value) {
          blacklistedValues[param] = value
          urlParams.delete(param)
        }
      })

      const paramsObject = Object.fromEntries(urlParams)

      // Save non-blacklisted query parameters to session storage if any exist
      if (Object.keys(paramsObject).length) {
        sessionStorage.setItem('query_params', JSON.stringify(paramsObject))
      }
    }
  }

  const values = {
    portraitIsReady: state.portraitIsReady,
    portraitInstance: state.portraitInstance,
    updateIdentity,
    updatePageMeta,
    pushEvent,
    persistTrackingParams
  }

  return (
    <AnalyticsContext.Provider value={values}>
      {children}
    </AnalyticsContext.Provider>
  )
}

AnalyticsProvider.propTypes = {
  children: PropTypes.any
}
